import { MenuOptionName } from '@maximizer/core/shared/ui/enums';

export type CrmActionVariationMatch = {
  variations: string[];
  result: {
    action: MenuOptionName;
    icon: string;
    actionTranslationKey: string;
    typeTranslationKey: string;
  };
};

export const CRM_ACTIONS: CrmActionVariationMatch[] = [
  {
    variations: ['Write an email', 'Write email', 'Email'],
    result: {
      action: MenuOptionName.WriteEmail,
      icon: 'envelope',
      actionTranslationKey: 'outlook.actions.writeEmail',
      typeTranslationKey: 'outlook.types.email',
    },
  },
  {
    variations: ['Schedule a meeting', 'Schedule meeting', 'Meeting', 'Appointment'],
    result: {
      action: MenuOptionName.ScheduleMeeting,
      icon: 'calendar',
      actionTranslationKey: 'outlook.actions.scheduleMeeting',
      typeTranslationKey: 'outlook.types.meeting',
    },
  },
  {
    variations: ['Schedule a to-do', 'Schedule to do', 'Schedule to-do', 'To-do', 'Task'],
    result: {
      action: MenuOptionName.ScheduleToDo,
      icon: 'circle-check',
      actionTranslationKey: 'outlook.actions.scheduleToDo',
      typeTranslationKey: 'outlook.types.toDo',
    },
  },
  {
    variations: ['Add a note', 'Add note', 'Note'],
    result: {
      action: MenuOptionName.AddNote,
      icon: 'note-sticky',
      actionTranslationKey: 'outlook.actions.addNote',
      typeTranslationKey: 'outlook.types.note',
    },
  },
  {
    variations: ['Interaction'],
    result: {
      action: MenuOptionName.LogInteraction,
      icon: '',
      actionTranslationKey: 'outlook.actions.logInteraction',
      typeTranslationKey: 'outlook.types.interaction',
    },
  },
  {
    variations: ['document', 'file'],
    result: {
      action: MenuOptionName.AddDocument,
      icon: '',
      actionTranslationKey: 'outlook.types.document',
      typeTranslationKey: 'outlook.types.document',
    },
  },
  {
    variations: ['addressBook', 'contact', 'client'],
    result: {
      action: MenuOptionName.CreateOpportunity,
      icon: '',
      actionTranslationKey: 'outlook.types.addressBook',
      typeTranslationKey: 'outlook.types.addressBook',
    },
  },
];

export function getCRMActionFromVariation(
  inputVariation: string,
): CrmActionVariationMatch | undefined {
  return CRM_ACTIONS.find((action) =>
    action.variations.some(
      (variation) => variation.toLowerCase() === inputVariation.toLowerCase(),
    ),
  );
}
